import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import SideBarProductSearch from '../../call-details-side-bar/side-bar-product-search/side-bar-product-search';
import { DiscountInput } from '../../../../components/discount-input/DiscountInput';
import CallDetailsCartItem from '../../call-details-side-bar/call-showroom-tab/call-details-cart-component/call-details-cart-item/call-details-cart-item';
import ProductItem from '../../standalone-cart-details-side-bar/product-item/product-item';
import { MAX_CART_PRODUCTS } from '../../../../utils/consts';
import { currencyFormatter } from '../../../../utils';
import { useCartStandaloneProvider } from '../cart-standalone-provider/cart-standalone-provider';

import "./cart-standalone-tab.scss";

const CartStandaloneTab = ({ visible, copyLabel }) => {
      const shops = useSelector((state) => state.shops);
      const caazamUser = useSelector((state) => state.user.user);

      const {
            standaloneCartProducts,
            onUpdateStandaloneCartProducts,
            discount,
            standaloneCartRecoveryUrl,
            createdSACartId
      } = useCartStandaloneProvider();

      const activeShopId = shops.activeShopId;
      const activeShopData = shops.availableShops[activeShopId];

      const neededDetailsForProductSearch = {
            id: "",
            shopId: activeShopId,
            countryCode: activeShopData?.billingAddress?.countryCode,
      };

      const totalSum = useMemo(() => (
            standaloneCartProducts.reduce((sum, product) => sum + product.quantity * product.price, 0)
      ), [JSON.stringify(standaloneCartProducts)]);

      return (
            <div className={`cart-standalone-tab${visible ? ' visible' : ''}`}>
                  {!standaloneCartRecoveryUrl && (<SideBarProductSearch
                        disabled={standaloneCartProducts.length >= MAX_CART_PRODUCTS}
                        placeholder={'Search for products'}
                        products={standaloneCartProducts}
                        onUpdateProducts={onUpdateStandaloneCartProducts}
                        userId={caazamUser.id}
                        {...neededDetailsForProductSearch}
                  />)}

                  {standaloneCartProducts.length > 0 && <div className={'cart-component-products-counter'}>
                        <p className={standaloneCartProducts.length >= MAX_CART_PRODUCTS ? 'limit' : ''}>
                              {standaloneCartProducts.length} product{standaloneCartProducts.length !== 1 ? 's' : ''} in
                              cart
                              {standaloneCartProducts.length >= MAX_CART_PRODUCTS
                                    && ' (max)'
                              }
                        </p>
                  </div>}

                  <div className='cart-component-products-wrapper' id={'search-dropdown'}>
                        {standaloneCartProducts?.map((product) => (
                              !standaloneCartRecoveryUrl ? (
                                    <CallDetailsCartItem
                                          key={(product.variantId ?? product.productId) + 'selectedProduct'}
                                          product={product}
                                          call={neededDetailsForProductSearch}
                                          onUpdateProducts={onUpdateStandaloneCartProducts}
                                          products={standaloneCartProducts}
                                    />
                              ) : (
                                    <ProductItem
                                          key={(product.variantId ?? product.productId) + 'viewProduct'}
                                          product={product}
                                    />
                              )
                        ))}
                  </div>

                  <>
                        {!standaloneCartRecoveryUrl ? (
                              <DiscountInput cartId="" shopId={activeShopId} cartDiscount={discount} isSACartMode />
                        ) : (
                              discount && (
                                    <DiscountInput
                                          isViewMode
                                          cartId={createdSACartId}
                                          shopId={activeShopId}
                                          cartDiscount={discount}
                                    />
                              )
                        )}
                        <div className="tab-total">
                              <p>Total: </p>
                              <p>{currencyFormatter(totalSum, activeShopData?.currencyCode)}</p>
                        </div>
                  </>
            </div>
      )
};

export default CartStandaloneTab;
